import Config from "../config";

const getUserTimeFormat = (timeFormat = Config.user.time_format) => {
    return timeFormat === '24h' ? 'HH:mm' : 'hh:mm a';
};

export default getUserTimeFormat;